import { APPNAME, APPOWNER } from "../../utils/utils.constants";
import logo from '../../assets/logo.png';
import { NavLink } from "react-router-dom";
import { routes } from "../../utils/utils.routes";

export const Logo: React.FC = () => {
    return (
        <div className="logo-container w-100">
            <NavLink to={routes.HOME} className="custom-logo-link w-100">
                <img
                    width="50"
                    height="30"
                    className="custom-logo"
                    alt={APPNAME}
                    src={logo}
                />
                <div className="vertical-barre" />
                <div className="logo-text logo-text-group" style={{}}>
                    <h1 className="page-section-header__title">{APPOWNER}</h1>
                    <p>{APPNAME}</p>
                </div>
            </NavLink>
        </div>
    );
};